import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Dialog, DialogActions } from 'src/components/molecules/dialog';
import { useCancelBooking } from 'src/features/bookings/api/hooks/use-cancel-booking';

interface Props extends DialogActions {
  bookingToken: string;
}

export const CancelBookingDialog = ({
  open,
  onCancel,
  bookingToken,
}: Props) => {
  const { t } = useTranslation(['bookings', 'common']);

  const { mutate: cancelBooking, isPending: isCancellingBooking } =
    useCancelBooking(onCancel);

  const handleCancelBooking = () => {
    cancelBooking(bookingToken);
  };

  return (
    <Dialog
      variant="warning"
      open={open}
      onCancel={onCancel}
      onConfirm={handleCancelBooking}
      confirmButtonText={t(
        'bookings:common.cancelBookingDialog.confirmButtonText',
      )}
      cancelButtonText={t('common:button.no')}
      isConfirmButtonSubmitting={isCancellingBooking}
      title={t('bookings:common.cancelBookingDialog.title')}>
      <Typography variant="body2">
        {t('bookings:common.cancelBookingDialog.message')}
      </Typography>
    </Dialog>
  );
};
